import { createAction, props } from '@ngrx/store';

export const storePricingFormState = createAction(
    '[PricingForm] Store Pricing FormState',
    //props<{ formState: Record<string, unknown> }>()
    props<{ formState: Record<string, unknown> }>()
  )
  